/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { StandadCard } from "../../../../../../components/Cards";
import {
  AccountCircle,
  AdminPanelSettings,
  ManageAccounts,
  Receipt,
  StickyNote2,
} from "@mui/icons-material";
import { TabPanel } from "../../../../../../components/Tabs/TabPanel";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { PageLoader } from "../../../../../../components/PageLoader/PageLoader";
import { LoadState, MODULE_IDS } from "../../../../../../constants/enums";
import { useDispatchWrapper } from "../../../../../../hooks";
import { TabsList } from "../../../../../../components/Tabs/TabsList";
import { CommAutomobileCustomerInfo } from "./CustomerInfo/CustomerInfo";
import { CommAutomobilePriorPolicy } from "./PriorPolicy/PriorPolicy";
import { CommAutomobilePolicyAdmin } from "./PolicyAdmin/PolicyAdmin";
import { CommAutomobilePremium } from "./Premium/Premium";
import { CommAutomobileAttachment } from "./Attachment/Attachment";
import { useParams } from "react-router-dom";
import { fetchCommAutomobileCustomerInfoAsync } from "../../../../../../redux/commAutoPolicy/commAutoBasicDetails/commAutoBasicDetailsActions";
import { CommAutomobilePolicyAdminManager } from "./PolicyAdminManager/PolicyAdminManager";
import { usePremissions } from "../../../../../../security/PremissionsProvider/PremissionsProvider";
import { TabsUncontrolledProvider } from "../../../../../../contexts/TabsContextProvider/TabsContextUncontrolledProvider";

export const CommAutomobileBasicDetails = () => {
  const { customerId, customerPolicyId } = useParams() as {
    customerId?: number;
    customerPolicyId?: number;
  };
  const [tab, setTab] = React.useState(0);
  const { customerInfo, customerPoliycId: savedCustomerPolicyId } = useSelector(
    (storeState: IStoreState) => storeState.commAuto.basicDetails
  );
  const {premissionsList} = usePremissions();
  const showAdminManager = premissionsList.find((x)=>{
    if(x.module_id === MODULE_IDS.COMM_AUTO_POLICY_ADMIN_MANAGER && x.show_module){
      return true;
    }
    return false;
  })

  const dispatch = useDispatchWrapper();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };
  
  const changeStep = (newStep: number) => {
    setTab(newStep);
  }

  React.useEffect(() => {
    if (customerPolicyId) {
      dispatch(fetchCommAutomobileCustomerInfoAsync(customerPolicyId));
    }
  }, [customerPolicyId]);

  if (!customerId) {
    return null;
  }

  return (
    <PageLoader
      loading={customerInfo.loading === LoadState.InProgress}
      error={customerInfo.error ? { message: customerInfo.error } : null}
    >
      <TabsUncontrolledProvider step={tab} changeStep={changeStep}>
      <StandadCard>
        <TabsList
          sx={{ mb: 1 }}
          varaint="fullWidth"
          selectedTab={tab}
          tabs={[
            { label: "Customer Info", icon: <AccountCircle /> },
            {
              label: "Policy Admin",
              icon: <StickyNote2 />,
              disabled: !savedCustomerPolicyId,
            },
            {
              label: "Prior Policy",
              icon: <AdminPanelSettings />,
              disabled: !savedCustomerPolicyId,
            },
            {
              label: "Policy Admin Manager",
              icon: <ManageAccounts />,
              hidden: !showAdminManager,
              disabled: !savedCustomerPolicyId,
            },
            {
              label: "Premium",
              icon: <Receipt />,
              disabled: !savedCustomerPolicyId,
            },
          ]}
          onChange={handleChange}
        />
        <TabPanel value={tab} index={0}>
          <CommAutomobileCustomerInfo
            customerPolicyId={savedCustomerPolicyId}
            customerId={customerId}
          />
        </TabPanel>
        {savedCustomerPolicyId && (
          <>
           <TabPanel value={tab} index={1}>
              <CommAutomobilePolicyAdmin
                customerpolicyId={savedCustomerPolicyId}
              />
            </TabPanel>
            <TabPanel value={tab} index={2}>
              <CommAutomobilePriorPolicy
                customerpolicyId={savedCustomerPolicyId}
              />
            </TabPanel>
           
            <TabPanel value={tab} index={3}>
              <CommAutomobilePolicyAdminManager
                customerpolicyId={savedCustomerPolicyId}
              />
            </TabPanel>
            <TabPanel value={tab} index={4}>
              <CommAutomobilePremium customerpolicyId={savedCustomerPolicyId} />
            </TabPanel>
          </>
        )}
      </StandadCard>
      </TabsUncontrolledProvider>
    </PageLoader>
  );
};
